<template>
  <mu-card class="lcAudioPlayer nonSelectable" v-show="isAudioReady">
    <mu-card-text style="display: flex;flex-direction: row;width: 410%;">
      <div class="left">
        <mu-icon
          class="playButton"
          @click.native="playOrPause()"
          style="cursor: pointer; font-size: 28px"
          color="#1692DA"
          :value="isPlaying ? 'pause_circle_outline' : 'play_circle_outline'"
        ></mu-icon>
      </div>
      <div style="float:left" >
        <div class="playerBar">
          <div>
            <vue-slider
              v-model="currentDuration"
              :bgStyle="playerSliderOptions.bgStyle"
              :processStyle="playerSliderOptions.processStyle"
              :sliderStyle="playerSliderOptions.sliderStyle"
              :height="playerSliderOptions.height"
              :width="playerSliderOptions.width"
              :dotSize="playerSliderOptions.dotSize"
              tooltip="false"
              :min="0"
              :max="duration"
              @callback="durationChanged"
              @drag-start="dragSeekDurationStarted()"
              @drag-end="dragSeekDurationEnded()"
              :speed="0"
            ></vue-slider>
          </div>
        </div>
      </div>
      <div class="durationStats left">
        {{currentTime}}/{{audioDuration}}
      </div>
      <div
        class="volume-controls left"
        v-if="isAudioReady === true">
        <mu-icon
          @click.native="mute()"
          color="#1692DA"
          style="float:left; cursor:pointer;"
          :value="audioIcon"
        >
        </mu-icon>
        <span v-show="isVolumeControlsVisible === true" class="control desktopOnly">
          <vue-slider
            :direction="volumeSliderOptions.direction"
            v-model="volume"
            tooltip="false"
            :min="volumeSliderOptions.min"
            :max="volumeSliderOptions.max"
            :interval="volumeSliderOptions.interval"
            :speed="volumeSliderOptions.speed"
            :width="volumeSliderOptions.width"
            :height="volumeSliderOptions.height"
            @drag-start="dragVolumeStarted()"
            @drag-ended="dragVolumeEnded()"
            @callback="setVolume"
          ></vue-slider>
        </span>
      </div>
      <audio
        ref="audioFile"
        :src="url"
        preload="auto"
        controls
        style="display: none"
      ></audio>
    </mu-card-text>
  </mu-card>
</template>
<script>

  import vueSlider from 'vue-slider-component/src/vue2-slider.vue'
  import audioPlayerMixin from './AudioPlayerMixin'

  const playerSliderOptions = {
    width: 130,
    height: 16,
    dotSize: 16,
    bgStyle: {
      backgroundColor: '#D8D8D8'
    },
    processStyle: {
      backgroundColor: "#7ECB46"
    },
    sliderStyle: {
      backgroundColor: '#FFFFFF'
    }
  };

  const volumeSliderOptions = {
    height: 8,
    width: 68,
    direction: "horizontal",
    speed: 0.1,
    interval: 0.1,
    min: 0,
    max: 1
  };

  export default {
    name: 'audio-player',
    mixins: [audioPlayerMixin],
    components: {vueSlider},
    name: 'audio-player',
    props: {
      url: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        isVolumeControlsVisible: true,
        isPlaying: false,
        isMuted: false,
        volumeBeforeMuted: 0,
        isAudioReady: false,
        userSeeking: false,
        audio: undefined,
        percentage: 0,
        duration: 0,
        volume: 0.5,
        currentDuration: 0,
        currentTime: '00:00',
        playerSliderOptions: playerSliderOptions,
        volumeSliderOptions: volumeSliderOptions
      }
    },
    mounted() {
      let self = this;
      self.initAudio();
    }
  }
</script>
<style scoped lang="less">

  @controlButtonBackgroundColor: #efefef;

  .nonSelectable > * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .lcAudioPlayer {
    min-height: 58px;
    position: relative;

    .playButton {
      margin: -2px;
      position: relative;
      left: -4px;
    }
    @media (min-width: 400px) {
      width: 390px;
    }
    @media (max-width: 600px) {
      width: 320px;
    }

    .left {
      float: left;
    }

    .controlButton {
      background: @controlButtonBackgroundColor !important;
    }
    .durationStats {
      margin-top: 2px;
    }

    .volumeControlLayout {
      position: absolute;
      bottom: 8px;
      right: 24px;
    }
    .playerBar {
      margin-top: -4px;
      margin-left: 8px;
      margin-right: 8px;
    }
    .volume-controls {
      margin-left: 16px;
      @media (max-width: 600px) {
        .control {
          display: none;
        }
      }
      @media (min-width: 600px) {
        .control {
          display: inline-block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AudioPlayer.vue?1ddf835f